import { handleActions } from 'redux-actions';
import update from 'react-addons-update';
import * as constants from '../constants/index';

export const initialState = {
  isFetching: false,
  isPosting: false,
  data: [],
  singleBooking: {},
  cancellationPolicy: [],
  userMangoPayInfo: null,
  cottages: [],
  error: null,
  success: null,
  offerStale: false,
};

const setFetchBookingsInfoRequest = (state) =>
  update(state, {
    isFetching: { $set: true },
    error: { $set: {} },
  });

const setFetchBookingsInfoSuccess = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    userMangoPayInfo: { $set: action.payload.userMangoPayInfo },
    cottages: { $set: action.payload.cottages },
  });

const setFetchBookingsInfoFailure = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    error: { $set: action.payload.error },
  });

const setFetchBookingsRequest = (state) =>
  update(state, {
    isFetching: { $set: true },
    error: { $set: {} },
    data: { $set: [] },
  });

const setFetchBookingsSuccess = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    data: { $set: action.payload.data },
  });

const setFetchBookingsFailure = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    error: { $set: action.payload.error },
  });

const setFetchBookingRequest = (state) =>
  update(state, {
    isFetching: { $set: true },
    singleBooking: { $set: {} },
    error: { $set: {} },
    offerStale: { $set: false },
  });

const setFetchBookingSuccess = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    singleBooking: { $set: action.payload.data },
  });

const setFetchBookingFailure = (state, action) =>
  update(state, {
    isFetching: { $set: false },
    error: { $set: action.payload.error },
  });

const setFetchCancellationPolicySuccess = (state, action) =>
  update(state, {
    cancellationPolicy: { $set: action.payload.cancellationPolicy },
  });

const setFetchCancellationPolicyFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
  });

const postBookingRequest = (state) =>
  update(state, {
    isPosting: { $set: true },
  });

const postBookingSuccess = (state, action) =>
  update(state, {
    isPosting: { $set: false },
    success: { $set: { code: 'informationSaved' } },
    singleBooking: { $set: action.payload },
    error: { $set: {} },
  });

const postBookingFailure = (state, action) =>
  update(state, {
    isPosting: { $set: false },
    error: { $set: action.payload.error },
  });

const postBookingIdle = (state) =>
  update(state, {
    success: { $set: null },
    error: { $set: null },
  });

const postBookingActionRequest = (state) =>
  update(state, {
    isPosting: { $set: true },
  });

const postBookingActionSuccess = (state, action) =>
  update(state, {
    isPosting: { $set: false },
    success: { $set: { code: 'informationSaved' } },
    singleBooking: { $set: action.payload },
    error: { $set: {} },
  });

const postBookingActionFailure = (state, action) =>
  update(state, {
    isPosting: { $set: false },
    error: { $set: action.payload.error },
  });

const putBookingSuccess = (state, action) =>
  update(state, {
    error: { $set: null },
    success: { $set: { code: 'informationSaved' } },
    ...(action.payload ? { singleBooking: { $set: action.payload } } : {}),
  });

const putBookingFailure = (state, action) =>
  update(state, {
    error: { $set: action.payload.error },
    success: { $set: null },
  });

const putBookingRequest = (state) =>
  update(state, {
    error: { $set: null },
    success: { $set: null },
  });

const putBookingIdle = (state) =>
  update(state, {
    error: { $set: null },
    success: { $set: null },
  });

const setOfferStale = (state) =>
  update(state, {
    offerStale: { $set: true },
    isPosting: { $set: false },
  });

const clearOfferStale = (state) =>
  update(state, {
    offerStale: { $set: false },
  });

export default handleActions(
  {
    [constants.FETCH_BOOKINGS_INFO_REQUEST]: setFetchBookingsInfoRequest,
    [constants.FETCH_BOOKINGS_INFO_SUCCESS]: setFetchBookingsInfoSuccess,
    [constants.FETCH_BOOKINGS_INFO_FAILURE]: setFetchBookingsInfoFailure,

    [constants.FETCH_BOOKINGS_REQUEST]: setFetchBookingsRequest,
    [constants.FETCH_BOOKINGS_SUCCESS]: setFetchBookingsSuccess,
    [constants.FETCH_BOOKINGS_FAILURE]: setFetchBookingsFailure,

    [constants.FETCH_BOOKING_REQUEST]: setFetchBookingRequest,
    [constants.FETCH_BOOKING_SUCCESS]: setFetchBookingSuccess,
    [constants.FETCH_BOOKING_FAILURE]: setFetchBookingFailure,

    [constants.FETCH_CANCELLATION_POLICY_SUCCESS]: setFetchCancellationPolicySuccess,
    [constants.FETCH_CANCELLATION_POLICY_FAILURE]: setFetchCancellationPolicyFailure,

    [constants.POST_BOOKING_REQUEST]: postBookingRequest,
    [constants.POST_BOOKING_SUCCESS]: postBookingSuccess,
    [constants.POST_BOOKING_FAILURE]: postBookingFailure,
    [constants.POST_BOOKING_IDLE]: postBookingIdle,

    [constants.BOOKING_ACTION_REQUEST]: postBookingActionRequest,
    [constants.BOOKING_ACTION_SUCCESS]: postBookingActionSuccess,
    [constants.BOOKING_ACTION_FAILURE]: postBookingActionFailure,

    [constants.PUT_BOOKING_REQUEST]: putBookingRequest,
    [constants.PUT_BOOKING_SUCCESS]: putBookingSuccess,
    [constants.PUT_BOOKING_FAILURE]: putBookingFailure,
    [constants.PUT_BOOKING_IDLE]: putBookingIdle,

    [constants.BOOKING_OFFER_STALE_SET]: setOfferStale,
    [constants.BOOKING_OFFER_STALE_CLEAR]: clearOfferStale,
  },
  initialState,
);
